const enum AreaCodeActionType {
  SET_SELECT_CODE = 'SET_SELECT_CODE',
  SET_AREA_CODES = 'SET_AREA_CODES',
}

export { AreaCodeActionType };
